import React from "react";
import PageHero from "./PageHero";
import { FaLeaf, FaHotel, FaHandsHelping } from "react-icons/fa";
import img13 from "../../media/images/garary/g10.jpg";
import img8 from "../../media/images/garary/g8.jpg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import directorImg from "../../media/images/garary/g31.jpeg";


function About() {
  const { ref, inView } = useInView({
  triggerOnce: true, // runs only once
  threshold: 0.3,    // when 30% is visible
});
  return (
    <>
      {/* HERO */}
      <PageHero
        title="About Us"
        subtitle="Discover the story behind Father’s House Church Resort Hotel"
        image={img13}
      />

      {/* ABOUT SECTION */}
      <div className="container py-5">
        <div className="row align-items-center">
          
          <div className="col-md-6 mb-4" data-aos="fade-right">
            <img
              src={img8}
              alt="About"
              className="img-fluid rounded shadow"
            />
          </div>

          <div className="col-md-6" data-aos="zoom-in">
            <h2 className="mb-3">Welcome to Father’s House</h2>
            <p>
              A peaceful and spiritual destination designed for relaxation,
              retreats, and conferences.
            </p>
            <p>
              We combine comfort, nature, and faith to give you a unique
              experience away from the noise of everyday life.
            </p>

            <Link to="/blog">
              <button className="btn btn-success mt-3">
                Explore More
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* WHY CHOOSE US */}
      {/* WHY CHOOSE US */}
<div className="bg-light py-5">
  <div className="container text-center">
    <h2 className="mb-5" data-aos="fade-up">Why Choose Us</h2>

    <div className="row">
      
      {/* Peaceful Environment */}
      <div className="col-md-4 mb-4" data-aos="zoom-in">
        <div className="p-4 shadow rounded bg-white h-100">
          <FaLeaf size={40} className="text-success mb-3" />
          <h5>Peaceful Environment</h5>
          <p>Perfect for retreats and relaxation.</p>
        </div>
      </div>

      {/* Modern Facilities */}
      <div className="col-md-4 mb-4" data-aos="zoom-in" data-aos-delay="100">
        <div className="p-4 shadow rounded bg-white h-100">
          <FaHotel size={40} className="text-success mb-3" />
          <h5>Modern Facilities</h5>
          <p>Comfortable rooms and conference spaces.</p>
        </div>
      </div>

      {/* Spiritual Growth */}
      <div className="col-md-4 mb-4" data-aos="zoom-in" data-aos-delay="200">
        <div className="p-4 shadow rounded bg-white h-100">
          <FaHandsHelping size={40} className="text-success mb-3" />
          <h5>Spiritual Growth</h5>
          <p>A place to connect, reflect, and grow.</p>
        </div>
      </div>

    </div>
  </div>
</div>

      {/* STATS SECTION */}
      {/* STATS SECTION */}
<div className="container py-5 text-center" ref={ref}>
  <div className="row">
    
    <div className="col-md-3" data-aos="fade-up">
      <h2 className="text-success">
        {inView && <CountUp end={50} duration={2} />}+
      </h2>
      <p>Rooms Available</p>
    </div>

    <div className="col-md-3" data-aos="fade-up" data-aos-delay="100">
      <h2 className="text-success">
        {inView && <CountUp end={100} duration={2} />}+
      </h2>
      <p>Events Hosted</p>
    </div>

    <div className="col-md-3" data-aos="fade-up" data-aos-delay="200">
      <h2 className="text-success">
        {inView && <CountUp end={500} duration={2} />}+
      </h2>
      <p>Happy Guests</p>
    </div>

    <div className="col-md-3" data-aos="fade-up" data-aos-delay="300">
      <h2 className="text-success">
        {inView && <CountUp end={10} duration={2} />}+
      </h2>
      <p>Years Experience</p>
    </div>

  </div>
</div>

{/* OUR HEART & HERITAGE */}
<div className="container py-5">
  <div className="row align-items-center">

    {/* Image */}
    <div className="col-lg-5 mb-4" data-aos="zoom-in">
      <img
        src={img13} // or another suitable image
        alt="Our Heritage"
        className="img-fluid rounded shadow"
      />
    </div>

    {/* Content */}
    <div className="col-lg-7" data-aos="zoom-in" data-aos-delay="100">
      <h2
        className="fw-bold text-success mb-4"
        style={{ textTransform: "uppercase" }}
      >
        Our Heart & Heritage
      </h2>

      <p style={{ lineHeight: "1.9", fontSize: "1.05rem" }}>
        Father’s House Church Resort Hotel is more than a destination—it is
        an extension of a God-given vision dedicated to faith, hospitality,
        service, and transformation. Rooted in Christian values, our mission
        is to create a welcoming environment where guests experience peace,
        renewal, and the love of Christ.
      </p>

      <p style={{ lineHeight: "1.9", fontSize: "1.05rem" }}>
        As part of the wider Father’s House ministry, we are committed to
        nurturing spiritual growth, strengthening communities, and providing
        a place where individuals, families, churches, and organizations can
        gather for worship, fellowship, retreats, conferences, and rest.
      </p>

      <p style={{ lineHeight: "1.9", fontSize: "1.05rem" }}>
        We believe that when faith meets compassion, lives are transformed,
        hope is restored, and purpose is awakened. Through our commitment to
        excellence and Christian hospitality, we strive to serve every guest
        with integrity, kindness, and genuine care.
      </p>

      <blockquote
        className="mt-4 ps-4 border-start border-4 border-success"
        style={{
          color: "#6c8f68",
          fontStyle: "italic",
          fontSize: "1.1rem",
        }}
      >
        "Father’s House Church Resort Hotel is a place designed not only for
        rest and comfort, but for spiritual encounter, renewal, and lasting
        impact."
      </blockquote>
    </div>

  </div>
</div>

      {/* MANAGING DIRECTOR SECTION */}
      <div className="container py-5">
        <div className="row align-items-center">

          {/* Director Image */}
          <div
            className="col-md-5 mb-4"
            data-aos="fade-right"
          >
            <img
              src={directorImg}
              alt="Managing Director"
              className="img-fluid rounded shadow"
              style={{
                height: "750px",
                width: "100%",
                objectFit: "cover",
              }}
            />
          </div>

          {/* Director Message */}
          <div
            className="col-md-7"
            data-aos="zoom-in"
          >
            <h2 className="mb-3 text-success">
              A Message from the Managing Director
            </h2>

            <p style={{ lineHeight: "1.9" }}>
              Welcome to Father’s House Church Resort Hotel, a place where
              faith, peace, comfort, and hospitality come together in harmony.
              We are honored to provide an environment that allows every guest
              to rest, reconnect with God, and experience true serenity away
              from the pressures of everyday life.
            </p>

            <p style={{ lineHeight: "1.9" }}>
              As a Christian-centered resort, our vision goes beyond providing
              accommodation. We are committed to creating a spiritually uplifting
              atmosphere where individuals, families, ministries, and
              organizations can gather for relaxation, fellowship, prayer,
              conferences, retreats, and personal renewal.
            </p>

            <p style={{ lineHeight: "1.9" }}>
              At Father’s House, we believe in serving with love, humility,
              integrity, and excellence. Every guest is valuable to us, and we
              strive to ensure that your stay is filled with warmth, comfort,
              safety, and memorable experiences inspired by Christian values.
            </p>

            <p style={{ lineHeight: "1.9" }}>
              Surrounded by a peaceful environment and modern facilities, our
              resort is designed to refresh both the body and the spirit.
              Whether you are visiting for business, ministry, family
              gatherings, or quiet reflection, we pray that your time here
              becomes a source of encouragement, joy, and spiritual renewal.
            </p>

            <p style={{ lineHeight: "1.9" }}>
              Thank you for choosing Father’s House Church Resort Hotel.
              We look forward to welcoming and serving you with genuine care
              and Christian hospitality.
            </p>

            <h5 className="mt-4 mb-0 text-dark">
              Rev. Dr. Edward Sali and Mrs. Kate Sali
            </h5>

            <small className="text-muted">
              Managing Director
            </small>
          </div>

        </div>
      </div>

      {/* CALL TO ACTION */}
      <div
        className="text-white text-center py-5"
        style={{
          backgroundImage: `url(${img13})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div style={{ background: "rgba(0,0,0,0.6)", padding: "40px" }}>
          <h2 data-aos="fade-up">Ready to Experience Peace & Comfort?</h2>
          
          <Link to="/rooms">
            <button className="btn btn-success mt-3" data-aos="fade-up">
              Book Your Stay
            </button>
          </Link>
        </div>
      </div>
    </>
  );
}

export default About;